import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Alert, Box, FormLabel } from '../../AORedesign';

const DocUploader = ({ label, acceptableFileTypes, invalidFileTypeMsg, setDocumentDetails }) => {
  const [showError, setShowError] = useState(false);

  const handleChange = async (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const ext = file.name.substr(file.name.lastIndexOf('.') + 1);
      const fileTypes = acceptableFileTypes.split(',').map((item) => item.trim().replace('.', ''));
      if (fileTypes.includes(ext)) {
        setShowError(false);
        setDocumentDetails({
          extension: ext,
          docContent: await getBase64Data(file),
        });
      } else {
        setShowError(true);
      }
    }
  };

  const getBase64Data = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64EncodedData = reader.result.split(',')[1];
        resolve(base64EncodedData);
      };
      reader.onerror = reject;
    });

  return (
    <>
      <FormLabel htmlFor="news-doc-file" style={{ marginRight: 15 }}>
        {label}
      </FormLabel>
      <Box component="input" id="news-doc-file" accept={acceptableFileTypes} type="file" onChange={handleChange} />

      {showError && (
        <Box mb={2}>
          <Alert message={invalidFileTypeMsg} severity="error" />
        </Box>
      )}
    </>
  );
};

DocUploader.propTypes = {
  label: PropTypes.string,
  acceptableFileTypes: PropTypes.string,
  invalidFileTypeMsg: PropTypes.string,
  setDocumentDetails: PropTypes.func,
};

export default DocUploader;
